import _ from 'lodash'
import { layoutId } from '~/utils/helper'

export const state = () => ({
    // layout: '',
    currMenu: -1,
    currMenuPath: [],
    showMenu: false,
    authUser: null,
    menuList: [
        {
            title: '首页',
            href: '/',
            active: true
        },
        {
            title: '商家服务',
            href: '/services',
            active: false,
            children: [
                {
                    title: '我们的产品',
                    children: [
                        {
                            title: 'OA办公',
                            text: '综合OA管理系统',
                            icon: '',
                            href: '/services/oa'
                        },
                        {
                            title: 'CRM客户管理',
                            text: '专业电商CRM，更快了解客户',
                            icon: '',
                            href: '/services/crm'
                        },
                        {
                            title: 'OMS订单管理',
                            text: '全渠道订单管理，提高效率',
                            icon: '',
                            href: '/services'
                        },
                        {
                            title: 'WMS仓库管理',
                            text: '库存信息一网打尽，提高资源利用率',
                            icon: '',
                            href: '/services/wms'
                        },
                        {
                            title: '商城管理',
                            text: '一站式购物',
                            icon: '',
                            href: '/services/shop'
                        },
                        {
                            title: 'FMS财务管理',
                            text: '服务一切交易',
                            icon: '',
                            href: '/services/fms'
                        },
                        // {
                        //     title: 'TMS物流管理',
                        //     text: '物流快递一键查询',
                        //     icon: '',
                        //     href: '/services/tms'
                        // },
                    ]
                },
                {
                    title: '解决方案',
                    children: [
                        {
                            title: '营销中心',
                            text: '优惠券，赠品，满减送，订单返现，限时折扣，秒杀',
                            icon: '',
                            href: '/services/marketing'
                        },
                        {
                            title: '系统应用',
                            text: '一客一价；第三方对接',
                            icon: '',
                            href: '/services/application'
                        },
                    ]
                }
            ]
        },
        {
            title: '渠道合作',
            href: '/cooperation',
            active: false
        },
        {
            title: '特色服务',
            href: '/trait',
            active: false
        },
        {
            title: '常见问题',
            href: '/trait/help',
            active: true
        },
        {
            title: '关于我们',
            href: '/about',
            active: false
        }
    ],
    layout: [
    ],
    helpType: '',
    helpTypeName: '',
    helpMean: 3
})

export const getters = {
    helpMean (state) {
        return state.helpMean
    },
    currMenu (state) {
        return state.currMenu
    },
    currMenuPath (state) {
        return state.currMenuPath
    },
    showMenu (state) {
        return state.showMenu
    },
    authUser (state) {
        return state.authUser
    },
    menuList (state) {
        return state.menuList || []
        // let data = '[]'
        // if (typeof localStorage !== 'undefined') {
        //     data = JSON.parse(localStorage.getItem('menuList') || data)
        // }
        // return _.isEmpty(data)
        //     ? state.menuList
        //     : data
    },
    layout (state) {
        return state.layout
    },
    helpType (state) {
        return state.helpType
    },
    helpTypeName (state) {
        return state.helpTypeName
    }
}



// WEBPACK FOOTER //
// ./store/state.js